import gql from 'gql-tag'

export const BASE_COMMUNICATION_FRAGMENT = gql`
  fragment BaseCommunication on Communication {
    resourceType
    id
    status
    basedOn {
      id
    }
    topic {
      id
      text
    }
    recipient {
      id
    }
    sender {
      id
    }
    sent
    note {
      text
    }
  }
`

export const BASE_COMMUNICATION_WITH_PRACTITIONER_SENDER = gql`
  fragment BaseCommunicationWithPractitionerSender on Communication {
    ...BaseCommunication
    sender {
      resource {
        ... on Practitioner {
          ...BasePractitioner
        }
      }
    }
  }
`
